// import { ProfileCard } from "./ProfileCard";
import {
  Heart,
  ArrowLeft,
  Star,
  MessageCircle,
  X,
  Check,
  Clock,
  Eye,
  Badge,
  Filter,
  Search,
  Users,
  Sparkles,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Menu, User, Crown } from "lucide-react";
import { Button } from "./ui/button";
import { motion } from "framer-motion";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "./ui/alert-dialog";
import { useDispatch, useSelector } from "react-redux";
import { clearUserState } from "../redux/userSlice";
import {
  getWithoutTokenAPI,
  getWithTokenAPI,
  postWithTokenAPI,
} from "../util/Api";

import { Input } from "./ui/input";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { Horizontalslider } from "./horizontalslider.jsx";
import { Toaster } from "react-hot-toast";
import { setCurrentPage } from "../redux/navigationSlice.js";
import { TrendingProfilesSlider } from "./Trending-profile-slider.jsx";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { setProfileCount } from "../redux/profileCountSlice.js";

export function MatchesPage({ onNavigate }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [matchList, setMatchList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredMatches, setFilteredMatches] = useState([]);
  const data = useSelector((state) => state.user);
  const token = data?.userId?.accessToken;
  const id = data?.userId?.user?._id;

  const { t, i18n } = useTranslation();
  var layoutType = "showall";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showSubscribeDialog, setShowSubscribeDialog] = useState(false);
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);
  const handleLogout = () => {
    setShowLogoutDialog(true);
  };

  const [completion, setCompletion] = useState(0);
  //-----------fetch all forcompletion bar
  // useEffect(() => {
  //   const fetchAllDetails = async () => {
  //     const response = await getWithTokenAPI(token, `/profile/get_all/${id}`);
  //     if (!response?.data) return;

  //     const { basicProfile, professionalProfile, preference, zodiac } =
  //       response.data;

  //     let completion = 0;

  //     if (basicProfile) completion = 1;
  //     if (professionalProfile) completion = 2;
  //     if (preference) completion = 3;

  //     // ✅ Check if all rasi houses are filled (not empty arrays)
  //     if (zodiac && zodiac.rasi) {
  //       const allHouses = Object.values(zodiac.rasi);
  //       const hasData = allHouses.some((house) => house && house.length > 0);

  //       if (hasData) {
  //         completion = 4;
  //       }
  //     }
  //     setCompletion(completion);
  //   };

  //   fetchAllDetails();
  // }, [token, id]);

  const [sentInterestIds, setSentInterestIds] = useState([]);
  useEffect(() => {
    const fetchInterests = async () => {
      if (!token || !id) return;
      try {
        const sentresponse = await getWithTokenAPI(
          token,
          `/interest/get_send_interest?user_id=${id}`
        );
        const receivers = sentresponse?.data?.receivers || [];
        if (receivers?.length > 0) {
          const receiverIds = receivers.map((r) => r.user_id);
          setSentInterestIds(receiverIds);
          console.log("Receiver IDs stored:", receiverIds);
        } else {
          setSentInterestIds([]); // No receivers found
        }
      } catch (error) {
        console.error("Error fetching interests:", error);
        setSentInterestIds([]);
      }
    };

    fetchInterests();
  }, [token, id]);

  useEffect(() => {
    if (!matchList?.length) return;

    setMatchList((prevList) => {
      const updatedList = prevList.map((item) => {
        const userId = item?.user_id;
        const isInterested = sentInterestIds.includes(userId);
        return { ...item, interest: isInterested };
      });
      const prevInterests = prevList.map((i) => i.interest);
      const newInterests = updatedList.map((i) => i.interest);

      const isSame =
        JSON.stringify(prevInterests) === JSON.stringify(newInterests);

      return isSame ? prevList : updatedList;
    });
  }, [sentInterestIds, matchList]);

  const handleProfileClick = async (profile) => {
    if (!token) return;
    try {
      const profileId = profile?.basicProfile?.user_id || profile?.user_id;
      const profilename = profile?.basicProfile?.name || profile?.name;
      if (!profileId) {
        console.warn("No profile id found for", profile);
        return;
      }

      // onNavigate?.("view-profile", profileId);
      const payload = { viewer_id: id, viewed_id: profileId };
      const response = await postWithTokenAPI(
        token,
        `/profile-view/track`,
        payload
      );

      if (response?.statusCode === 200) {
        console.log("viewer count updated");
        navigate(`/view-profile/${profilename}`, {
          state: { profileId: profileId },
        }); // Naviga
        window.scrollTo({ top: 0, behavior: "smooth" });
        dispatch(setProfileCount(response?.data?.unique_profiles_viewed_today));
      } else if (response?.statusCode === 403) {
        setShowSubscribeDialog(true);
      } else {
        console.log("error in updating viewer count", response);
      }
    } catch (error) {
      console.error("Error in viewed profile post", error);
    }
  };
  useEffect(() => {
    const fetchmatchesList = async () => {
      try {
        const response = await getWithTokenAPI(
          token,
          `/profiles/matching?user_id=${id}`
        );
        if (response?.statusCode === 200) {
          setMatchList(response?.data?.profiles || []);
        }
      } catch (error) {
        console.error("Error fetching matches:", error);
      }
    };
    if (token && id) fetchmatchesList();
  }, [token, id]);

  // Filter matches based on search query
  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredMatches(matchList);
    } else {
      const filtered = matchList.filter(
        (match) =>
          match.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          match.district?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          match.city?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          match.religion?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          match.education?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          match.profession?.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredMatches(filtered);
    }
  }, [searchQuery, matchList]);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50/30">
      <Toaster position="top-right" />
      <Helmet>
        <title>Avan Aval - Matches</title>
        <meta name="description" content="This is my page description." />
        <meta name="keywords" content="React, Helmet, SEO" />
      </Helmet>
      <Header />
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12">
          {/* <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl shadow-lg mb-6">
      <Sparkles className="h-4 w-4 text-white" />
    </div> */}
          <h1 className="text-2xl font-bold text-gray-900 mb-3 mt-6">
            {t("Find Your Perfect Match")}
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            {t(
              "Connect with verified profiles that share your values and lifestyle"
            )}
          </p>
        </div>

        {/* Stats & Search Card */}
        {/* <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-8"style={{width:"70%",margin:"auto",borderLeft:"5px solid red",borderRadius:"5px"}}> */}
        {/* <div className="flex flex-col lg:flex-row items-center justify-between gap-6" style={{borderRight:"5px solid red",borderRadius:"5px"}}> */}
        {/* Stats */}
        {/* <div className="flex items-center space-x-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-gray-900 mb-1">
                  {filteredMatches?.length}
                </div>
                <div className="text-sm text-gray-500 font-medium">
                  {t("Total Matches")}
                </div>
              </div>
              <div className="h-12 w-px bg-gray-200"></div>
              <div className="flex items-center space-x-2 text-sm text-gray-600">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <span>{t("Active profiles ready to connect")}</span>
              </div>
            </div> */}

        {/* Search */}
        <div
          className="flex-1  max-w-2xl mb-3"
          style={{ width: "90%", margin: "auto" }}
        >
          <div className="flex gap-3">
            <div className="flex-1 ">
              {/* <Search className="relative left-4 top-5 transform -translate-y-1/2 h-5 w-5 text-gray-400" /> */}
              <Input
                placeholder={t("Search by name, location")}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full h-10 border-gray-300 bg-white focus:border-red-600 rounded-l"
                style={{ borderLeft: "3px solid red" }}
              />
            </div>
            {searchQuery && (
              <Button
                onClick={() => setSearchQuery("")}
                variant="outline"
                className="h-10 px-6 border-gray-300 hover:bg-gray-50 rounded-l"
              >
                {t("Clear")}
              </Button>
            )}
          </div>
        </div>
        {/* </div>
        </div> */}
      </div>
      <div className="max-w-7.5xl mx-auto">
        {/* Matches Content */}
        {filteredMatches?.length > 0 ? (
          <div className="grid grid-cols-1 gap-4">
            <TrendingProfilesSlider
              profiles={filteredMatches}
              layoutType="Showall"
              onNavigate={(profile) => {
                const id = profile?.basicProfile?.user_id || profile?.user_id;
                console.log("Clicked profile id:", id);
                handleProfileClick(profile);
              }}
            />
          </div>
        ) : (
          /* Empty State */
          <div className="text-center py-4">
            <div
              className="max-w-lg mx-auto "
              style={{
                boxShadow: "0px 0px 3px silver",
                borderRadius: "10px",
                padding: "5px 40px",
                // backgroundColor:"white",
                // border:"1px solid grey"
              }}
            >
              {/* Illustration */}
              <div className="relative">
                <div className="w-24 h-24 mx-auto bg-gradient-to-br from-blue-50 to-indigo-100 rounded-3xl flex items-center justify-center shadow-inner">
                  <Users className="h-12 w-12 text-blue-600" />
                </div>
                {/* <div className="absolute -top-2 -right-2 w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center shadow-sm">
                  <span className="text-xs font-bold text-white">?</span>
                </div> */}
              </div>

              {/* Content */}
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                {searchQuery
                  ? t("No matches found")
                  : t("Ready to find your match?")}
              </h3>
              <p className="text-gray-600 mb-8 leading-relaxed">
                {searchQuery
                  ? t(
                      "Try adjusting your search terms or explore different criteria to discover more profiles."
                    )
                  : t(
                      "Complete your profile to unlock personalized match recommendations and start your journey."
                    )}
              </p>

              {/* Action */}
              <div className="space-y-3">
                <Button
                  onClick={() => navigate("/profile")}
                  className=" bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
                >
                  {t("Complete Your Profile")}
                </Button>
                
              </div>

              {/* Tip */}
              <div className="mt-4 p-4 bg-blue-50 rounded-xl border border-blue-500 mb-4">
                <p className="text-sm text-blue-700 flex items-center justify-center gap-2">
                  <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                  {t(
                    "Adding photos and preferences increases match quality by 3x"
                  )}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
      <AlertDialog
        open={showSubscribeDialog}
        onOpenChange={setShowSubscribeDialog}
      >
        <AlertDialogContent className="max-w-sm text-center">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-red-600 text-xl font-semibold">
              🔔 {t("Subscription Required")}
            </AlertDialogTitle>
            <AlertDialogDescription className="text-gray-600 mt-2">
              {t("Upgrade your plan to explore more matches")}
            </AlertDialogDescription>
          </AlertDialogHeader>

          <div className="flex justify-center gap-3 mt-4">
            <AlertDialogCancel
              onClick={() => setShowSubscribeDialog(false)}
              className="cursor-pointer border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-lg"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
              onClick={() => {
                setShowSubscribeDialog(false);
                dispatch(setCurrentPage("subscription"));
              }}
            >
              {t("Subscribe Now")}
            </AlertDialogAction>
          </div>
        </AlertDialogContent>
      </AlertDialog>
      <Footer />
    </div>
  );
}
